export const APP_NAME = "Golf Kraken";
// Use || instead of ?? so an empty-string env var also falls back to the default
export const API_BASE = import.meta.env.VITE_API_BASE_URL || "/api/v1";

export const NAV_TABS = [
  { id: "home", label: "Home", icon: "Home", path: "/" },
  { id: "events", label: "Events", icon: "Calendar", path: "/events" },
  { id: "friends", label: "Friends", icon: "Users", path: "/friends" },
  { id: "chat", label: "Chat", icon: "MessageCircle", path: "/chat" },
  { id: "stats", label: "Stats", icon: "BarChart2", path: "/stats" },
  { id: "more", label: "More", icon: "MoreHorizontal", path: "/more" },
] as const;

export type NavTabId = (typeof NAV_TABS)[number]["id"];
